import request from "@/utils/request";

// 列表
export function getList(data) {
  return request({
    // url: "/api/cert/get",
    url: "/api/cert",
    method: "post",
    data,
  });
}
